import styled from "styled-components";
import WizardModal from "../../../components/wizard-modal/wizard-modal.component";

export const CMWizardModal = styled(WizardModal)((props) => ({
  "*": {
    zIndex: "999999999",
  },
  ".custom-fund-input": {
    paddingRight: 0,
  },

  "& .dropdownerror": {
    color: `#a80000`,
    textAlign: "left",
    fontSize: "0.75rem",
    lineHeight: "0.5",
    margin: 0,
    paddingLeft: 5,
  },
  "& .center-absolute": {
    width: "100vw",
    maxWidth: "995px",

    "& > div": {
      padding: "40px",

      "& .wizardStep-title": {
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontWeight: 500,
        marginLeft: 0,
        marginRight: 0,
        fontSize: props.theme.fontSizes.h3,
      },
    },
  },

  "& button": {
    display: "block",
    margin: "auto",
  },
}));

export const CMFormContainer = styled.div((props) => ({
  display: "flex",
  padding: "40px 2rem",
  justifyContent: "space-evenly",
  borderRadius: "36px",
  margin: "26px 0 51px",
  backgroundColor: props.theme.palette.blue.notifications,

  "& > div": {
    flex: "1 1 0%",
    paddingRight: "1rem",
  },
}));

export const CMAmountContainer = styled.div((props) => ({
  display: "flex",
  width: "25%",
  flexDirection: "column",
  padding: "40px 2rem",
  borderRadius: "36px",
  margin: "26px 0 51px",
  backgroundColor: props.theme.palette.blue.notifications,

  "& > div": {
    flex: 1,
    paddingRight: "1rem",
  },
}));

export const CMReviewFee = styled.div((props) => ({
  marginTop: "24px",
}));

export const CMModalConfirmation = styled.div((props) => ({
  "& .description_confirmation": {
    fontSize: "1.3rem",
  },
  "& .container_buttons": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "50px",
    padding: "10px",

    "& .button_accept": {
      fontSize: "1.5rem",
      background: "#349ccc",
      border: "none",
      width: "100px",
      color: "white",
      borderRadius: "30px",
      transition: "0.3s",
      border: "1px solid transparent",
    },

    "& .button_accept:hover": {
      color: "#349ccc",
      background: "white",
      border: "1px solid #349ccc",
    },

    "& .button_reject": {
      fontSize: "1.5rem",
      background: "gray",
      border: "1px solid transparent",
      width: "100px",
      color: "white",
      borderRadius: "30px",
      transition: "0.3s",
    },

    "& .button_reject:hover": {
      color: "gray",
      background: "white",
      border: "1px solid gray",
    },
  },
}));

export const customStyles = {
  overlay: {
    zIndex: "9999",
  },
  borderRadius: "50px",
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "500px",
    maxHeight: "85%",
    borderRadius: 30,
    "@media(max-width: 575px)": {
      maxWidth: "300px",
    },
    "@media(max-width: 479px)": {
      maxWidth: "270px ! important",
    },
  },
};

export const customStylesDeposit = {
  overlay: {
    zIndex: "9999",
  },
  borderRadius: "50px",
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "700px",
    maxHeight: "85%",
    borderRadius: 30,
    "@media(max-width: 575px)": {
      maxWidth: "300px",
    },
    "@media(max-width: 479px)": {
      maxWidth: "270px ! important",
    },
  },
};

export const customStylesConfirmationModal = {
  overlay: {
    zIndex: "99999",
  },
  borderRadius: "50px",
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    padding: "20px",
    transform: "translate(-50%, -50%)",
    width: "100%",
    maxWidth: "420px",
    minHeight: "90px",
    borderRadius: 30,
    "@media(max-width: 575px)": {
      maxWidth: "300px",
    },
    "@media(max-width: 479px)": {
      maxWidth: "270px !important",
    },
  },
};

export const H2 = styled.h2(() => {
  return {
    fontWeight: 500,
    fontSize: "18px",
    textAlign: "left",
    marginBottom: "10px",
    marginTop: "20px",
  };
});

export const Title = styled.h2(() => {
  return {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    borderBottom: `solid 1px #a80000`,
    "& > h2": {
      fontWeight: 600,
      marginBottom: "10px",
      fontSize: "22px",
    },
  };
});
